module.exports = __webpack_public_path__ + "img/greenlock.d43a132e.svg";